import React from 'react';
import { getTheme } from '@uifabric/styling';
import { Stack } from 'office-ui-fabric-react';
import { formatDate } from 'buzz_lib_shared';
import { ClearableDatePicker } from '../DatePicker/ClearableDatePicker';
import { FieldErrorMessage } from '../Validation/FieldErrorMessage';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ClearableDateRangePicker = props => {
  const datePickerStyles = {
    iconProps: {
      styles: {
        root: {
          color: getTheme().palette.themePrimary
        }
      }
    },
    styles: {
      field: {
        color: getTheme().palette.themePrimary
      }
    }
  };
  return /*#__PURE__*/_jsxs(Stack, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      horizontal: true,
      horizontalAlign: "start",
      tokens: {
        childrenGap: 15
      },
      children: [/*#__PURE__*/_jsx(ClearableDatePicker, {
        onSelectDate: date => date && props.onDateFromChange(date),
        textField: datePickerStyles,
        minDate: props.minDateFrom,
        maxDate: props.maxDateFrom,
        value: props.dateFromValue,
        formatDate: formatDate,
        placeholder: props.dateFromPlaceholder || 'Select date from',
        disabled: props.isDisabled,
        "data-id": props.dateFromDataId,
        styles: props.datePickerStyles,
        labelStyles: props.labelStyles,
        initialPickerDate: props.datePickerFrom.initialDate,
        label: props.datePickerFrom.label,
        onClear: props.datePickerFrom.onClear
      }), /*#__PURE__*/_jsx(ClearableDatePicker, {
        onSelectDate: date => date && props.onDateToChange(date),
        textField: datePickerStyles,
        minDate: props.minDateTo,
        maxDate: props.maxDateTo,
        value: props.dateToValue,
        formatDate: formatDate,
        placeholder: props.dateToPlaceholder || 'Select date to',
        disabled: props.isDisabled,
        "data-id": props.dateToDataId,
        styles: props.datePickerStyles,
        labelStyles: props.labelStyles,
        initialPickerDate: props.datePickerTo.initialDate,
        label: props.datePickerTo.label,
        onClear: props.datePickerTo.onClear
      })]
    }), /*#__PURE__*/_jsx(Stack, {
      children: props.errorMessage && /*#__PURE__*/_jsx(FieldErrorMessage, {
        children: props.errorMessage
      })
    })]
  });
};